export default __webpack_public_path__ + "static/media/480_dummy2016-beauty02-mobile-de.5d21f2c6.png";